
import './App.scss';
import Projects from './Components/Projects/Projects';

function App() {
  return (
    <div className="App">
      <div className='Container'>

      
      <header className="App-header">
        
        <h1>Excel Projects</h1>
        
      </header>
      <Projects />
      </div>
      
    </div>
  );
}

export default App;
